/* import __COLOCATED_TEMPLATE__ from './lowpass-firstorder.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();